const CommentEditingHelper = () => (
  <div className="alert alert-info">
    <svg className="icon icon-info"><use xlinkHref="#icon-info_outline" /></svg>
    You can only add or edit one annotation at a time.
    Please Save or Cancel this annotation before working on another one
  </div>
);

export default CommentEditingHelper;
